import { copiarCenaTabletop } from './operacoes'
import { validarCenaTabletop } from './serializacao'
import type { CenaTabletop } from './tipos'

export interface RegistroMesa {
  titulo: string
  mensagem: string
}

export interface SessaoMesa {
  cena: CenaTabletop
  registros: readonly RegistroMesa[]
  debriefing: string
}

export function sessaoDaCena(cena: CenaTabletop): SessaoMesa {
  return { cena: copiarCenaTabletop(cena), registros: [], debriefing: '' }
}

export function desserializarSessaoMesa(json: string): SessaoMesa {
  const valor: unknown = JSON.parse(json)
  if (validarCenaTabletop(valor)) return sessaoDaCena(valor)
  if (typeof valor !== 'object' || valor === null)
    throw new Error('Sessão de mesa inválida.')
  const s = valor as Record<string, unknown>
  if (
    !validarCenaTabletop(s.cena) ||
    typeof s.debriefing !== 'string' ||
    !Array.isArray(s.registros) ||
    !s.registros.every(
      (r: unknown) =>
        typeof r === 'object' &&
        r !== null &&
        typeof (r as Record<string, unknown>).titulo === 'string' &&
        typeof (r as Record<string, unknown>).mensagem === 'string',
    )
  ) {
    throw new Error(
      'Sessão de mesa inválida: confira a cena, os registros e o debriefing.',
    )
  }
  return {
    cena: copiarCenaTabletop(s.cena),
    registros: s.registros.map((r) => ({
      titulo: r.titulo,
      mensagem: r.mensagem,
    })),
    debriefing: s.debriefing,
  }
}
